import React, { useRef, useEffect, useState } from "react";

// Rename component to start with uppercase
const NewsTicker = () => {
  const speed = 150;
  const newsitems = [
    `🌟 Use Code "ARUHI15" On Your First Purchase To Get 15% OFF On Your Order`,
    `🌟 Use Code "ARUHI15" On Your First Purchase To Get 15% OFF On Your Order`,
    `🌟 Use Code "ARUHI15" On Your First Purchase To Get 15% OFF On Your Order`,
  ];

  const tickerRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    // Calculate total width of all items
    if (tickerRef.current) {
      setWidth(tickerRef.current.scrollWidth);
    }
  }, [newsitems]);

  return (
    <div className="ticker-container  mt-[2rem] sm:mt-[1rem]">
      <div
        className="ticker"
        style={{
          animationDuration: `${width / speed}s`,
        }}
        ref={tickerRef}
      >
        {newsitems.concat(newsitems).map((item, index) => (
          <span key={index} className="ticker-item">
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default NewsTicker;
